export const NOTIFICATIONS_REFRESH_EVENT = 'fusa:notifications-refresh';
export const requestNotificationRefresh = () => window.dispatchEvent(new Event(NOTIFICATIONS_REFRESH_EVENT));

export const fetchUnreadCount = async () => {
  const response = await fetch('/apinotifications/unread-count');
  if (!response.ok) throw new Error('Unable to load unread notifications');
  const data = await response.json();
  return Number(data.count) || 0;
};
